
import { AGE_OPTIONS, GRADE_OPTIONS } from '@/utils/filter/filterOptions';
import { mapGetters, mapMutations } from 'vuex';
import ChildAgeFilter from './ChildAgeFilter.vue';
import FilterOptions from './FilterOptions.vue';
import FilterSelector from './FilterSelector.vue';

export default {
  name: 'AgeNGradeFilter',
  components: {
    ChildAgeFilter,
    FilterOptions,
    FilterSelector,
  },
  data() {
    return {
      AGE_OPTIONS,
      GRADE_OPTIONS,
    };
  },
  computed: {
    ...mapGetters('search', ['selectedAgeFilter']),
    filters() {
      return this.selectedAgeFilter === 'age' ? AGE_OPTIONS : GRADE_OPTIONS;
    },
  },
  methods: {
    ...mapMutations('search', ['SET_SELECTED_AGE_FILTER']),
    onSelectTab(tabValue) {
      this.SET_SELECTED_AGE_FILTER(tabValue);
    },
  },
};
